// extracted by mini-css-extract-plugin
export var eventDateContainer = "eventDate-module--eventDateContainer--LQiIb";
export var eventDate = "eventDate-module--eventDate--gAhr-";
export var title = "eventDate-module--title--karlu";
export var date = "eventDate-module--date--3JzHl";
export var price = "eventDate-module--price--3kWTc";
export var addr = "eventDate-module--addr--1Elts";